export default "__VITE_ASSET__Dh358xCj__"